import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

const categoryLabels: Record<string, string> = {
  hanman: '韩漫',
  riman: '日漫',
  guoman: '国漫',
};

const categoryColors: Record<string, string> = {
  hanman: 'bg-primary-100 text-primary-700',
  riman: 'bg-accent-100 text-accent-800',
  guoman: 'bg-secondary-100 text-secondary-800',
};

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${categoryColors[comic.category]}`}>
            {categoryLabels[comic.category]}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
            comic.status === '连载中' ? 'bg-accent-500/90 text-white' : 'bg-foreground-600/80 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-white text-xs line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {comic.title}
      </h3>
      <div className="flex items-center gap-3 mt-1">
        <div className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs text-accent-600 font-medium">{comic.rating}</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-eye-line text-foreground-400 text-xs"></i>
          </div>
          <span className="text-xs text-foreground-500">
            {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
          </span>
        </div>
      </div>
      <p className="text-xs text-foreground-500 mt-1 truncate">{comic.latestChapter}</p>
    </Link>
  );
}